import { gql, useMutation, useQuery } from "@apollo/client";
import React, { useState } from "react";
import { TagListComponent } from "src/components/tags/TagListComponent";
import { Toast } from "src/hooks/toast";

interface Props {
  setEdit?: (e: boolean) => void;
  item: any;
}

const QUERY = gql`
  query supplierTagSuggestList {
    supplierTagSuggestList
  }
`;

const QUERY_SEARCH_TAG = gql`
  query searchProductTag($tag: String) {
    searchProductTag(tag: $tag)
  }
`;

const MUTATION_SAVE_TAG = gql`
  mutation saveProductTag($id: Int!, $tags: String!) {
    saveProductTag(id: $id, tags: $tags)
  }
`;

function ValidateExistTag({ text }: { text: string }) {
  const { data, loading } = useQuery(QUERY_SEARCH_TAG, {
    skip: !text,
    variables: {
      tag: text,
    },
  });

  if (loading || !data) {
    return <div></div>;
  }

  return <small className="text-danger">similar words already input is "{data.searchProductTag}"</small>;
}

export function TagsProduct({ setEdit, item }: Props) {
  const [search, setSearch] = useState("");
  const [tags, setTags] = useState(item.content.tags ? item.content.tags.split(",") : []);
  const [suggest, setSuggest] = useState([]);

  const { data } = useQuery(QUERY, {
    fetchPolicy: "no-cache",
    onCompleted: () => {
      setSuggest(data.supplierTagSuggestList.map((x: any) => x.tag));
    },
  });

  const [saveProductTag] = useMutation(MUTATION_SAVE_TAG, {
    refetchQueries: ["supplierProductRequestList", "supplierTagSuggestList", "productListV2"],
    onCompleted: (data) => {
      Toast.onShow("Product was change tags", "success", "right");
    },
  });

  const onSave = () => {
    saveProductTag({
      variables: {
        id: Number(item.id),
        tags: tags.join(","),
      },
    });
    if (setEdit) {
      setEdit(false);
    }
  };

  return (
    <div style={{ width: 150, overflow: "hidden" }}>
      <TagListComponent
        value={tags}
        onChange={(e: any) => {
          setTags(e);
          setSearch("");
        }}
        small
        suggestion={suggest}
        onChangeText={setSearch}
        class="lf-form-control form-control-sm"
      />
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <ValidateExistTag text={search} />
        <div className="mt-2 text-right">
          <button
            className="btn btn-danger btn-sm mr-2"
            onClick={() => {
              if (setEdit) {
                setEdit(false);
              }
            }}
          >
            Cancel
          </button>
          <button className="btn btn-primary btn-sm" onClick={onSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
